import { render, staticRenderFns } from "./c-info-card.vue?vue&type=template&id=53d75772&scoped=true&"
import script from "./c-info-card.vue?vue&type=script&lang=js&"
export * from "./c-info-card.vue?vue&type=script&lang=js&"
import style0 from "./c-info-card.vue?vue&type=style&index=0&id=53d75772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d75772",
  null
  
)

export default component.exports